import { type ReactElement, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CollectionCard, type Tab } from '../../InfoPageCards';
import { usePlaybookPageProps } from '../PlaybookPageContext';
import { PlaybookTabLayout } from '../PlaybookTabLayout';
import { PresentationsProvider } from '../PresentationsContext';
import { ArchivedPresentations } from './ArchivedPresentations';
import { PresentationsTable } from './PresentationsTable';

const presentationsTabs: Tab<'presentations' | 'archive'>[] = [
  { id: 'presentations', label: 'Presentations' },
  { id: 'archive', label: 'Archived' },
];

export const PresentationsTab = () => {
  const searchInputRef = useRef<{
    resetSearchInput: () => void;
  }>();
  const { innerTabId } = useParams<{
    innerTabId?: 'archive';
  }>();

  const tab = innerTabId || 'presentations';
  const navigate = useNavigate();
  const { rootPath } = usePlaybookPageProps();

  const tableByTabId: Record<'presentations' | 'archive', ReactElement> = {
    presentations: <PresentationsTable />,
    archive: (
      <PresentationsProvider isArchive={true}>
        <ArchivedPresentations />
      </PresentationsProvider>
    ),
  };

  return (
    <PlaybookTabLayout>
      <div className="pb-10">
        <CollectionCard
          ref={searchInputRef}
          currentTabId={tab}
          setTab={(tabId) => {
            searchInputRef.current.resetSearchInput();
            if (tabId === 'presentations') {
              navigate(`${rootPath}/presentations`);
            }
            if (tabId === 'archive') {
              navigate(`${rootPath}/presentations/archive`);
            }
          }}
          tabs={presentationsTabs}
          withSearch
          inputPlaceholder="Search for presentation name"
        >
          {tableByTabId[tab]}
        </CollectionCard>
      </div>
    </PlaybookTabLayout>
  );
};
